const INTERACTIVE_ELEMENTS = 'a, button, input, select, textarea, label, summary, iframe, video, audio, [role="button"], [role="link"], [contenteditable]:not([contenteditable="false"]), [data-row-action], .leaflet-container';

// A double click also emits a second click; the first click already opened the row.
export const isSingleLoadClick = event => !event.defaultPrevented && event.detail < 2;

export const shouldToggleLoadRow = event => {
  if (!isSingleLoadClick(event)) return false;
  const target = event.target?.closest ? event.target : event.target?.parentElement;
  if (target?.closest(INTERACTIVE_ELEMENTS)) return false;
  const selection = window.getSelection?.();
  if (selection?.toString().trim() && (event.currentTarget.contains(selection.anchorNode) || event.currentTarget.contains(selection.focusNode))) return false;
  return true;
};
